import { toast } from "react-toastify";
import dayjs from 'dayjs';

// import 'react-toastify/dist/ReactToastify.css';

const TOAST_SUCCESS = (message) => {
    return toast.success(message);
};

const TOAST_INFO = (message) => {
    return toast.info(message);
};

const TOAST_ERROR = (message) => {
    return toast.error(message);
};

const TOAST_WARNING = (message) => {
    return toast.warning(message);
};


// const convertToBase64 = async (file) => {
//   console.log(file)
//   console.log('video/mp4',file.type.includes("video"))
  
//     if (file.type.includes("video"))  return URL.createObjectURL(file);

//     return new Promise((resolve, reject) => {
//       const fileReader = new FileReader();
//       fileReader.onload = () => {
//         resolve(fileReader.result);
//       };
//       fileReader.onerror = reject;
//       file && fileReader.readAsDataURL(file);
//     });
//   };

const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (file.type.includes("video")) {
      const videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(file);

      videoElement.onloadedmetadata = () => {
        if (videoElement.duration <= 90) {
          const fileReader = new FileReader();
          fileReader.onload = () => {
            resolve(fileReader.result);
          };
          fileReader.onerror = reject;
          fileReader.readAsDataURL(file);
        } else {
          toast.error("Video duration must be 90 seconds or less.");
          URL.revokeObjectURL(videoElement.src);
          reject(new Error("Video duration exceeds 90 seconds."));

        }
      };
    } else {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = reject;
      fileReader.readAsDataURL(file);
    }
  });
};

const formatDate = (date, format) => {
  return dayjs(date).format(format);
};

const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Durations are saved as "X Hour(s) Y Minutes". Zero parts are dropped:
// "0 Hours 30 Minutes" -> "30 Minutes", "1 Hour 0 Minutes" -> "1 Hour",
// "1 Hour 30 Minutes" -> "1 Hour 30 Minutes". Text in any other shape is shown as-is.
const formatDuration = (duration) => {
  if (duration === null || duration === undefined || String(duration).trim() === "") return "N/A";

  const text = String(duration);
  const hoursMatch = text.match(/(\d+)\s*(?:Hours?|Hrs?)\b/i);
  const minutesMatch = text.match(/(\d+)\s*(?:Minutes?|Mins?)\b/i);
  if (!hoursMatch && !minutesMatch) return text;

  const hours = hoursMatch ? parseInt(hoursMatch[1], 10) || 0 : 0;
  const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) || 0 : 0;

  return [
      hours > 0 ? `${hours} Hour${hours > 1 ? 's' : ''}` : '',
      minutes > 0 ? `${minutes} Minute${minutes > 1 ? 's' : ''}` : ''
  ].filter(Boolean).join(' ') || "N/A";
};

// Activity price for display. A price of 0 (or no price) is "Free". When the
// currency is not known - e.g. before login, where the API returns USD prices
// without a currency - USD is used: "USD $25.00".
const displayPrice = (price, currencyCode, currencySymbol) => {
  const amount = Number(String(price ?? "").replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(amount) || amount === 0) return "Free";
  return `${currencyCode || "USD"} ${currencySymbol || "$"}${String(price).trim()}`;
};

export {
    TOAST_SUCCESS,
    TOAST_INFO,
    TOAST_ERROR,
    TOAST_WARNING,
    convertToBase64,
    formatDate,
    capitalizeFirstLetter,
    formatDuration,
    displayPrice
};